export interface CardState {
  ease: number;
  interval: number;
  reps: number;
  due: number;
  lapses: number;
  seen: boolean;
}

export type Quality = 0 | 1 | 2 | 3 | 4 | 5;

export function freshState(): CardState {
  return { ease: 2.5, interval: 0, reps: 0, due: Date.now(), lapses: 0, seen: false };
}

export function schedule(card: CardState, quality: Quality): void {
  if (quality < 3) {
    card.reps = 0;
    card.interval = 0;
    card.lapses++;
    card.due = Date.now() + 60 * 1000;
  } else {
    card.reps++;
    if (card.reps === 1) card.interval = 1;
    else if (card.reps === 2) card.interval = 3;
    else card.interval = Math.round(card.interval * card.ease);
    card.ease = Math.max(1.3, card.ease + 0.1 - (5 - quality) * (0.08 + (5 - quality) * 0.02));
    card.due = Date.now() + card.interval * 86_400_000;
  }
  card.seen = true;
}

export function masteryLevel(c: CardState): 0 | 1 | 2 {
  if (!c.seen) return 0;
  if (c.interval >= 7 && c.reps >= 3) return 2;
  return 1;
}

export function isDue(c: CardState, now: number = Date.now()): boolean {
  return c.seen && c.due <= now;
}
